import { useNavigate } from "react-router-dom"
import { Box, Grid } from "@mui/material"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { useLoader } from "src/hooks/useLoader"
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema"
import {
  FormOperacionNotaEstructurada,
  OperacionNotaEstructuradaDetalle,
  schemaFormOperacionNotaEstructurada
} from "./types/types";
import { useForm, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod/dist/zod";
import { OperacionNotaEstructuradaFields } from "./types/fields"
import toast from "react-hot-toast";
import { HttpNotaEstructurada } from "./api/httpNotaEstructurada";
import SeccionNotaEstructuradaDatosOperacion from "./components/SeccionNotaEstructuradaDatosOperacion";
import { z } from "../../../../lib";
import SeccionNotaEstructuradaCuentaNuevo from "./components/SeccionNotaEstructuradaCuentaNuevo";
import navigation from "src/navigation/vertical"
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion"


export const CuentaProvisionalFields = {
  IdProvisional: 'idProvisional',
  NroCuenta: 'nroCuenta',
  RazonSocial: 'razonSocial',
  CodMoneda: 'codMoneda',
  ImporteConcertacion: 'importe_Concertacion',
  ImporteDPV: 'importe_DPV',
  ImporteFOP: 'importe_FOP',
  BitEnvio: 'bitEnvio'
} as const

export const cuentaProvisional = z
  .object({
    [CuentaProvisionalFields.IdProvisional]: z.string(),
    [CuentaProvisionalFields.NroCuenta]: z.string(),
    [CuentaProvisionalFields.RazonSocial]: z.string(),
    [CuentaProvisionalFields.CodMoneda]: z.number(),
    [CuentaProvisionalFields.ImporteConcertacion]: z.number(),
    [CuentaProvisionalFields.ImporteDPV]: z.number(),
    [CuentaProvisionalFields.ImporteFOP]: z.number(),
  })

export type CuentaProvisional = z.infer<typeof cuentaProvisional>

type NuevoSistemaNotaEstructuradaProps = {
  codSistemaPrincipal: number
}

export const NuevoSistemaNotaEstructurada = (props: NuevoSistemaNotaEstructuradaProps) => {
  const { submitOperacion } = useSubmitOperacion();
  const { showLoader, hideLoader } = useLoader()

  const { setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  const [cuentasProvisionales, setCuentasProvisionales] = useState<CuentaProvisional[]>([])

  const formMethods = useForm<FormOperacionNotaEstructurada>({
    resolver: zodResolver(schemaFormOperacionNotaEstructurada),
    defaultValues: {
      [OperacionNotaEstructuradaFields.CodPais]: props.codSistemaPrincipal,
      [OperacionNotaEstructuradaFields.FechaAprobacion]: new Date(),
      [OperacionNotaEstructuradaFields.CodSectorComercial]: undefined,
    }
  })

  const alCrearOperacionNotaEstructurada = useCallback((data: FormOperacionNotaEstructurada, selected: number) => {
    if (!cuentasProvisionales.length) {
      toast.error('Debe cargar por lo menos una cuenta.');

      return;
    }

    const payload = {
      ...data,
      [OperacionNotaEstructuradaFields.Cuentas]: cuentasProvisionales,
      [OperacionNotaEstructuradaFields.BitEnvio]: selected !== 1,
      codPais: props.codSistemaPrincipal
    };

    submitOperacion(payload, {
      apiCall: HttpNotaEstructurada.post,
      successMessage: 'Guardado correctamente.',
    });
  }, [cuentasProvisionales, submitOperacion, props.codSistemaPrincipal]);


  useEffect(() => {
    let onSend = () => console.log('on send test')
    onSend = () => formMethods.handleSubmit(data => alCrearOperacionNotaEstructurada(data, 2))
    setSendPromise(onSend)
  }, [formMethods, alCrearOperacionNotaEstructurada])


  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionNotaEstructuradaDatosOperacion
            formMethods={formMethods}
            codSistemaPrincipal={props.codSistemaPrincipal}
            codSistema={codSistema}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionNotaEstructuradaCuentaNuevo
            codPais={props.codSistemaPrincipal}
            cuentasProvisionales={cuentasProvisionales}
            setCuentasProvisionales={setCuentasProvisionales}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
